import React from "react";
import Reveal from "../common/Reveal";
import NetworkBackground from "../common/NetworkBackground";

const Hero = () => {
  return (
    <section className="relative overflow-hidden bg-gradient-to-b from-primary-50 to-white py-16 lg:py-24">
      <div className="pointer-events-none absolute inset-0 -z-10">
        <NetworkBackground className="absolute inset-0 h-full w-full" density={40} />
      </div>

      <Reveal className="relative mx-auto max-w-3xl px-4 text-center sm:px-6 lg:px-8">
        <span className="inline-block rounded-full bg-primary-100 px-4 py-1.5 text-sm font-semibold tracking-wide text-primary-700">
          CASE STUDY
        </span>
        <h1 className="mt-6 break-keep text-4xl font-bold leading-tight text-primary-900 sm:text-5xl">
          도입 사례
        </h1>
        <p className="mt-6 break-keep text-lg leading-relaxed text-gray-600">
          MTST의 MES·AI 솔루션을 도입한 제조기업들의 실제 성과입니다.
          데이터 기반의 품질 개선과 생산성 향상을 숫자로 확인해보세요.
        </p>
      </Reveal>
    </section>
  );
};

export default Hero;
